import { useCallback, useState } from 'react';
export var TabNavigationHotkeyEvent;
(function (TabNavigationHotkeyEvent) {
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["NextTab"] = 0] = "NextTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["PreviousTab"] = 1] = "PreviousTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["FirstTab"] = 2] = "FirstTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["LastTab"] = 3] = "LastTab";
    TabNavigationHotkeyEvent[TabNavigationHotkeyEvent["ActivateTab"] = 4] = "ActivateTab";
})(TabNavigationHotkeyEvent || (TabNavigationHotkeyEvent = {}));
function keyboardEventToTabNavigationEvent(e) {
    switch (e.key) {
        case ' ':
        case 'Space':
        case 'Enter':
            return TabNavigationHotkeyEvent.ActivateTab;
        case 'ArrowRight':
            return TabNavigationHotkeyEvent.NextTab;
        case 'ArrowLeft':
            return TabNavigationHotkeyEvent.PreviousTab;
        case 'Home':
            return TabNavigationHotkeyEvent.FirstTab;
        case 'End':
            return TabNavigationHotkeyEvent.LastTab;
        default:
            return undefined;
    }
}
export function useTabHotkeys(length) {
    var _a = useState(null), focusedTabIndex = _a[0], setFocusedTabIndex = _a[1];
    var handleKeyDown = useCallback(function (e) {
        switch (keyboardEventToTabNavigationEvent(e)) {
            case TabNavigationHotkeyEvent.FirstTab:
                e.preventDefault();
                setFocusedTabIndex(0);
                break;
            case TabNavigationHotkeyEvent.LastTab:
                e.preventDefault();
                setFocusedTabIndex(length - 1);
                break;
            case TabNavigationHotkeyEvent.NextTab:
                e.preventDefault();
                if (focusedTabIndex !== null) {
                    focusedTabIndex === length - 1
                        ? setFocusedTabIndex(0)
                        : setFocusedTabIndex(focusedTabIndex + 1);
                }
                break;
            case TabNavigationHotkeyEvent.PreviousTab:
                e.preventDefault();
                if (focusedTabIndex !== null) {
                    focusedTabIndex === 0
                        ? setFocusedTabIndex(length - 1)
                        : setFocusedTabIndex(focusedTabIndex - 1);
                }
                break;
            case TabNavigationHotkeyEvent.ActivateTab:
                // The default action of the button will handle this since ActivateTab only checks
                // for Space and Enter right now. If we find out that more activation methods are required,
                // we should add them here.
                break;
            default:
                break;
        }
    }, [focusedTabIndex, length]);
    return {
        focusedTabIndex: focusedTabIndex,
        onKeyDown: handleKeyDown,
        setFocusedTabIndex: function (index) { return setFocusedTabIndex(index); },
        clearFocusedTabIndex: function () { return setFocusedTabIndex(null); },
    };
}
//# sourceMappingURL=hotkeys.js.map